import React from "react";

const DashboardCommercialIcon = () => {
  return (
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none">
      <rect width="42" height="42" fill="#ddeeff" />
      <rect
        x="6"
        y="18"
        width="30"
        height="18"
        rx="1"
        fill="#14508c"
        opacity=".15"
      />
      <rect
        x="10"
        y="12"
        width="22"
        height="24"
        rx="1"
        fill="#14508c"
        opacity=".2"
      />
      <rect
        x="13"
        y="15"
        width="7"
        height="9"
        rx="1"
        fill="#14508c"
        opacity=".55"
      />
      <rect
        x="22"
        y="15"
        width="7"
        height="9"
        rx="1"
        fill="#14508c"
        opacity=".55"
      />
      <rect
        x="16"
        y="28"
        width="10"
        height="8"
        rx="1"
        fill="#14508c"
        opacity=".7"
      />
    </svg>
  );
};

export default DashboardCommercialIcon;
